import { Box, Typography } from '@mui/material';
import { formatNumber } from '../utils/format';
import OriginDot from './OriginDot';

type SplitBarProps = {
  fromProcesses: number;
  fromPeople: number;
  /** Show the "N process / N people" caption under the bar. */
  showLegend?: boolean;
};

/** Share of tickets created by processes (system-to-human) vs asked by people (peer-to-peer). */
const SplitBar = ({ fromProcesses, fromPeople, showLegend = true }: SplitBarProps) => {
  const total = fromProcesses + fromPeople;

  if (!total) {
    return null;
  }

  const processShare = Math.round((100 * fromProcesses) / total);

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        title={`${formatNumber(fromProcesses)} from processes · ${formatNumber(fromPeople)} from people`}
        sx={{ display: 'flex', height: 4, marginTop: 0.5, overflow: 'hidden', borderRadius: 1, bgcolor: 'divider' }}
      >
        <Box sx={{ width: `${processShare}%`, bgcolor: 'secondary.main' }} />
        <Box sx={{ width: `${100 - processShare}%`, bgcolor: 'info.main' }} />
      </Box>
      {showLegend ? (
        <Typography variant="caption" color="text.secondary" component="div" sx={{ display: 'flex', gap: 1.5 }}>
          <span>
            <OriginDot kind="process" />
            {formatNumber(fromProcesses)} process
          </span>
          <span>
            <OriginDot kind="person" />
            {formatNumber(fromPeople)} people
          </span>
        </Typography>
      ) : null}
    </Box>
  );
};

export default SplitBar;
